import { FC, SVGAttributes } from 'react';

const Error: FC<React.PropsWithChildren<React.PropsWithChildren<SVGAttributes<SVGElement>>>> = ({ ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12.0041 6.24316C11.2469 6.24316 10.6552 6.89697 10.7306 7.65043L11.2266 12.611C11.2666 13.0104 11.6027 13.3146 12.0041 13.3146C12.4056 13.3146 12.7417 13.0104 12.7816 12.611L13.2777 7.65043C13.353 6.89697 12.7614 6.24316 12.0041 6.24316Z"
        fill="#FF7C0A"
      />
      <path
        d="M12.0041 14.7289C11.223 14.7289 10.5898 15.3621 10.5898 16.1432C10.5898 16.9243 11.223 17.5574 12.0041 17.5574C12.7852 17.5574 13.4184 16.9243 13.4184 16.1432C13.4184 15.3621 12.7852 14.7289 12.0041 14.7289Z"
        fill="#FF7C0A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9996 2.09961C6.53199 2.09961 2.09961 6.53199 2.09961 11.9996C2.09961 17.4672 6.53199 21.8996 11.9996 21.8996C17.4672 21.8996 21.8996 17.4672 21.8996 11.9996C21.8996 6.53199 17.4672 2.09961 11.9996 2.09961ZM3.89961 11.9996C3.89961 7.5261 7.5261 3.89961 11.9996 3.89961C16.4731 3.89961 20.0996 7.5261 20.0996 11.9996C20.0996 16.4731 16.4731 20.0996 11.9996 20.0996C7.5261 20.0996 3.89961 16.4731 3.89961 11.9996Z"
        fill="#FF7C0A"
      />
    </svg>
  );
};

export default Error;
